'use es6';

// import PropTypes from 'prop-types';
// import ImmutablePropTypes from 'react-immutable-proptypes';
// import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import ShareButtonDropdown from '../../components/ShareButton/ShareButtonDropdown';
import { getTrack } from '../../selectors/trackSelectors';
import { getContentName } from '../../selectors/contentSelectors';
import { getLessonLanguage, getLessonName } from '../../selectors/lessonSelectors';
const makeMapStateToProps = (state, ownProps) => {
  const {
    match: {
      params: {
        trackId,
        lessonId,
        contentId
      } = {}
    }
  } = ownProps;
  const {
    auth
  } = state;
  const track = getTrack(state, {
    trackId
  });
  return {
    contentId,
    contentLanguage: getLessonLanguage(state, {
      lessonId
    }),
    contentName: getContentName(state, contentId),
    lessonId,
    lessonName: getLessonName(state, {
      lessonId
    }),
    onClick: ownProps.onClick,
    portalId: auth.portal.portal_id,
    trackId,
    trackName: track && track.get('name'),
    userId: auth.user.user_id
  };
};
export default withRouter(connect(makeMapStateToProps)(ShareButtonDropdown));